<uni-label>
    {{'ci.common.status' | translate}}
</uni-label>

<app-form-multi-select
    [options]="statusEntities$ | async"
    [value]="statusCurrentValue$ | async"
    (valueChange)="statusValueChange($event)"
    [defer]="0"
    [placeholder]="'ci.common.status' | translate"
></app-form-multi-select>
<uni-form-field-error *ngIf="ngControl.invalid && ngControl.touched">
    {{'ci.common.fieldRequired' | translate}}
</uni-form-field-error>